import React, { Component } from 'react';

import CV from 'react-cv';
import FiterAPI from '../fiterAPI';
import CVData from './CVData';

class FiterCV extends Component {
  constructor() {
    super();

    this.state = {
      error: false,
      result: {},
      loading: true
    };
  }

  async componentDidMount() {
    const userId = this.props.match.params.userId;
    const { error, ...result } = await FiterAPI.getCvData(userId);

    this.setState({
      error,
      result,
      loading: false
    });
    this.props.turnOffLoading();
  }

  render() {
    const { error, result, loading } = this.state;

    if (loading) return <></>;
    if (error) return 'Desculpe, não foi possível encontrar o CV.';
    return (
      <div>
        <CV {...result} />
      </div>
    );
  }
}

export default FiterCV;
